import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../services/config';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { CompartmentRuleItem } from '../../../administration';
import { AllocationViewEndpoint } from '../constants';

@Injectable({ providedIn: 'root' })
export class AllocationViewRuleBriefService {
  constructor(private http: WrapperHttpService) {}

  getRule(ruleId: number, hubId: number, compartmentId: number): Observable<CompartmentRuleItem> {
    const url = `${API_URL}${AllocationViewEndpoint.Hubs}/${hubId}${AllocationViewEndpoint.Compartments}/${compartmentId}${AllocationViewEndpoint.Rules}/${ruleId}`;

    return this.http.withLoading().get(url);
  }
}

